let hostname = window.location.hostname.replace('.ufsales.com.br', '')
const baseUrl = window.location.origin
let baseApiUrl = ''
let tenantId = ''

if (hostname.includes('yama')) {
  hostname = window.location.hostname.replace('.yama.com.br', '')
  
  tenantId = 'yama'
  baseApiUrl = 'https://api-vendas.yama.com.br'

  if (hostname == 'develop') baseApiUrl = 'https://api-dev-vendas.yama.com.br'

} else {

switch (hostname) {

  case 'localhost':
    baseApiUrl = 'http://localhost:5000'
    tenantId = (process?.env?.tenantId != 'undefined') ? process.env.tenantId : 'elettromec'
    break;

  case 'develop':
    baseApiUrl = 'https://api-develop.ufsales.com.br'
    tenantId = 'poc'
    break;

  case '':
    baseApiUrl = 'https://api.ufsales.com.br'
    tenantId = 'poc'
    break;

  default:
    baseApiUrl = `https://api-${hostname}.ufsales.com.br`
    tenantId = hostname
    break;
  }

}

if (process.env.NODE_ENV != 'production') console.info(`"UF Sales ${tenantId} - ${process.env.NODE_ENV}!`)

export {baseUrl, baseApiUrl, tenantId}